module.exports = __webpack_public_path__ + "static/media/80.5332c9a2.svg";